import $ from "jquery";
import tippy from "tippy.js";
import store from "../store";
import util from "../util";
import constants from "../constants";
import {getPageRuler} from "./page-ruler";

const PAGE_CONTENT_PANEL = '<ul>'
  + `<li><a class="move-page-up hint--right" data-hint="Move page up"><svg><use xlink:href="${constants.appPrefix + "/svg/icons.svg"}#app-arrow-up" /></svg></a></li>`
  + `<li><a class="move-page-down hint--right" data-hint="Move page down"><svg><use xlink:href="${constants.appPrefix + "/svg/icons.svg"}#app-arrow-down" /></use></svg></a></li>`
  + `<li><a class="copy-page hint--right" data-hint="Copy page"><svg><use xlink:href="${constants.appPrefix + "/svg/icons.svg"}#app-copy" /></svg></a></li>`
  + `<li><a class="remove-page hint--right" data-hint="Remove page"><svg><use xlink:href="${constants.appPrefix + "/svg/icons.svg"}#app-trash" /></svg></a></li>`
  + '</ul>';

const PAGE_CONTENT_PANEL_MOBILE = '<ul>'
  + `<li><a class="move-page-up"><</a></li>`
  + `<li><a class="move-page-down">></a></li>`
  + `<li><a class="copy-page"><svg><use xlink:href="${constants.appPrefix + "/svg/icons.svg"}#app-copy" /></svg></a></li>`
  + `<li><a id="add-page" class="add-page">+</a></li>`
  + `<li><a class="remove-page"><svg><use xlink:href="${constants.appPrefix + "/svg/icons.svg"}#app-trash" /></svg></a></li>`
  + '</ul>';

const PRINT_ADVISOR_PANEL = '<ul>'
  + '<li class="advisor-step advisor-step-one">Step 1</li>'
  + '<li class="advisor-step advisor-step-two">Step 2</li>'
  + '<li class="advisor-step advisor-step-three">Step 3</li>'
  + '<li class="advisor-step advisor-step-four">Step 4</li>'
  + '</ul>';

export function getPagePanel() {
    if (window.data.member.hasViewOnlyPermission) {
        return false;
    }

    if (!store.getState().isMobileVersion) {
        return `<div class="panel">${PAGE_CONTENT_PANEL}</div>`;
    } else {
        return `<div class="panel">${PAGE_CONTENT_PANEL_MOBILE}</div>`;
    }
}

export function getPageGuides() {
    return `<div class= "guides ${(util.getActiveDimensions().unit === 'in' && !util.isDigitalMenuBoard(util.getActiveDimensions().size.key)) ? 'bleeds' : ''}">`
      + '<span class="g-extra one"></span><span class="g-extra two"></span><span class="g-extra three"></span><span class="g-extra four"></span>'
      + `<span class="g-extra five"></span><span class="g-extra six"></span><span class="g-extra seven"></span><span class="g-extra eight"></span>${getPageRuler()}`
      + '<div class="bleed-top"></div><div class="bleed-left"></div><div class="bleed-btm"></div><div class="bleed-right"></div><div class="bleed-shadow-top"></div><div class="bleed-shadow-left"></div><div class="bleed-shadow-btm"></div><div class="bleed-shadow-right"></div><div class="bleed-shadow-fold-one"></div><div class="bleed-shadow-fold-two"></div><div class="bleed-shadow-fold-three"></div></div>'
      + '<div class= "guides folds">'
      + '<span class="fold-one"></span><span class="fold-two"></span><span class="fold-three"></span>'
      + '<span class="label-one"></span><span class="label-two"></span><span class="label-three"></span><span class="label-four"></span>'
      + '</div>';
}

export function replacePagePanel() {
    const $panels = $('.page').find('.panel');
    $panels.each(function () {
        const $this = $(this);
        $this.html(PAGE_CONTENT_PANEL);
        $this.find('.tippy').each(function () { tippy.one(this) });
    });
    refreshPagePanel();
}

export function refreshPagePanel() {
    const size = store.getState().designSize;
    const $removeLinks = $('.remove-page');
    const $copyLinks = $('.copy-page');

    const isMaxTwoPageDesign = util.isTakeout(size) || util.isFoldedMenu(size) || util.isTableTent(size) || util.isSandwichBoard(size);
    const isMaxThreePageDesign = store.getState().hasVideo && ((util.isPixelDesign() && !store.getState().isLogo) || store.getState().isDigitalMenuBoard);

    if ((isMaxTwoPageDesign && util.getNumberOfPages() > 1) || (isMaxThreePageDesign && util.getNumberOfPages() > 2)) {
        $copyLinks.hide();
        $removeLinks.removeClass('disabled');
    } else if (util.isSticker(size) || util.isLabel(size)) {
        $copyLinks.hide();
        util.getNumberOfPages() > 1 ? $removeLinks.removeClass('disabled') : $removeLinks.addClass('disabled');
    } else {
        $copyLinks.show();
        util.getNumberOfPages() > 1 ? $removeLinks.removeClass('disabled') : $removeLinks.addClass('disabled');
    }

    refreshPagePanelMoveLinks();
}

export function refreshPagePanelMoveLinks() {
    const size = store.getState().designSize;
    const $pages = $('.page');

    const $moveUpLinks = $('.move-page-up');
    const $moveDownLinks = $('.move-page-down');

    if (util.isLoyaltyCard(size) || util.isCommentCard(size) || util.isRackCard(size) || util.isGiftCertificate(size)) {
        $moveUpLinks.hide();
        $moveDownLinks.hide();
        return;
    }

    $moveUpLinks.show();
    $moveDownLinks.show();

    if ($pages.length > 0) {
        if ($pages.length === 1) {
            $moveUpLinks.addClass('disabled');
            $moveDownLinks.addClass('disabled');
        } else {
            $moveUpLinks.removeClass('disabled');
            $moveDownLinks.removeClass('disabled');

            $pages.eq(0).find('.move-page-up').addClass('disabled');
            $pages.eq($pages.length - 1).find('.move-page-down').addClass('disabled');
        }
    }
}
